import { IFieldDefinitionLogic } from '../../../interfaces/ifield-definition-logic.interface';
import { TextMetadataFieldDefLogic } from './text-metadata-field-def-logic';

export class FolderPathFieldDefinitionLogic extends TextMetadataFieldDefLogic implements IFieldDefinitionLogic {
    // Constructor.
    public constructor() {
        super('folderPath');
    }
}
